import { gql } from "@apollo/client";

export const FETCH_MESSAGES_FOR_CHAT = gql`
    query FetchMessagesForChat($id: ID!) {
        chat(id: $id) {
            id
            sizeInMessages
            messages {
                id
                createdAt
                updatedAt
                content
                type
                senderId
                chatId
                attachments {
                    id
                    fileName
                    tokens
                    fileSize
                }
                taskRecord {
                    id
                    metadata
                }
            }
        }
    }
`;
